module.exports = __webpack_public_path__ + "img/dashboard.4b9eb6fe.svg";